export const LoadingPiece = ({ label = "Loading" }: { label?: string }) => (
  <div className="panel-surface flex min-h-48 flex-col items-center justify-center gap-4 p-8 text-center">
    <div className="h-12 w-12 animate-spin rounded-md border-4 border-cmj-gold/30 border-t-cmj-red" />
    <p className="text-sm font-black uppercase text-cmj-mist">{label}</p>
  </div>
);
